/** @jsx jsx */
import React from 'react';
import { styled, jsx } from '@compiled/react';
import { Flex, xcss } from '@atlaskit/primitives';
import CommentIcon from '@atlaskit/icon/core/comment';
import Button from '@atlaskit/button';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';
import type { Props } from './types.tsx';

export const ExplainWorkflowButton = ({ onClick }: Props) => {
	const { formatMessage } = useIntl();

	return (
		<Flex xcss={flexContainerStyles} alignItems="start">
			<StyledButton
				appearance="subtle"
				shouldFitContainer
				onClick={onClick}
				iconBefore={<CommentIcon label="" />}
			>
				{formatMessage(messages.explainWorkflow)}
			</StyledButton>
		</Flex>
	);
};

// Move all styled/xcss/css components to the bottom
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const StyledButton = styled(Button)({
	alignItems: 'center',
	textAlign: 'left',
	color: token('color.text'),
	paddingTop: token('space.200'),
	paddingRight: token('space.150'),
	paddingBottom: token('space.200'),
	paddingLeft: token('space.150'),
	height: '100%',
});

const flexContainerStyles = xcss({
	flexGrow: 1,
	height: token('space.500'),
});
